/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { GetContractorEmployeeDetail } from "../../../../reduxToolkit/Contractor/ContractorApi";
import { DeleteItemsApi } from "../../../../reduxToolkit/Commons/CommonsApi";
import routes from "../../../../Routes/routes";
import { TABLES } from "../../../../Apis/Tables";
import { USER_TYPE_DOCUMENT } from "../../../../enums/userTypeEnum";
import {errorMsg} from "../../../../Apis/functions";

// Main component responsible for managing employee details from the contractor flow
const EmployeeDetailsBodyApp = (props) => {
    const dispatch = useDispatch(); // Hook to dispatch Redux actions
    const navigate = useNavigate(); // Hook to navigate between routes
    const { t } = useTranslation(); // Hook to handle translations
    const { id } = useParams(); // Extract the employee ID from the route parameters

    // Local state variables
    const [selectDocumentsForDelete, setSelectDocumentsForDelete] = useState([]); // Tracks selected documents for deletion
    const [isAllChecked, setIsAllChecked] = useState(false); // Flag to track "select all" checkbox status
    const [deleteDocShow, setDeleteDocShow] = useState(false); // Toggle for showing the document delete confirmation
    const [deletedFlag, setDeletedFlag] = useState(0); // Trigger for re-fetching data after deletion
    const [selectEmployeeForDelete, setSelectEmployeeForDelete] = useState(); // Tracks selected employee for deletion

    // Redux state selectors
    const {
        getContractorEmployeeDetail,
        createContractorDocValue,
        setContractorDocValue,
    } = useSelector((state) => state?.ContractorSlice);

    const { imageChangeCheck } = useSelector((state) => state.providersSlice);
    const { uploadImage } = useSelector((state) => state.sharedSlice);

    // useEffect to fetch employee details and update state whenever relevant data changes
    useEffect(() => {
        dispatch(GetContractorEmployeeDetail(id)); // Fetch employee details
        setSelectEmployeeForDelete([sessionStorage.getItem('elementForDelete')]); // Get employee ID to delete from session
    }, [
        createContractorDocValue,
        setContractorDocValue,
        uploadImage,
        imageChangeCheck,
        deletedFlag,
    ]);

    // Function to delete selected documents
    const deleteSelectedDocuments = (deleteItem) => {
        const tableName = USER_TYPE_DOCUMENT.CONTRACTOR_DOCUMENT;
        const body = deleteItem;

        if (body.length > 0) {
            dispatch(DeleteItemsApi({ tableName, body })).then(
                ({
                     payload: {
                         data: { success },
                     },
                 }) => {
                    if (success === true) {
                        // Refresh view and reset selection
                        setDeletedFlag(deletedFlag + 1);
                        setSelectDocumentsForDelete([]);
                        setIsAllChecked(false);
                    }
                },
            );
        }
    };

    // Function to delete the selected employee
    const deleteSelectedElement = (deleteItem) => {
        const tableName = TABLES.CONTRACTOR_EMPLOYEE;
        const body = deleteItem;

        if (body.length > 0) {
            dispatch(DeleteItemsApi({ tableName, body })).then(
                ({
                     payload: {
                         data: { success, code },
                     },
                 }) => {
                    if (success === true) {
                        // Navigate back to employee search page on successful deletion
                        navigate(routes.contractor.searchEmployee);
                    }else errorMsg(code);
                },
            );
        }
    };

    // Return variables and handlers for use in the component's UI
    return {
        t,
        deleteDocShow,
        setDeleteDocShow,
        selectDocumentsForDelete,
        selectEmployeeForDelete,
        setSelectDocumentsForDelete,
        isAllChecked,
        setIsAllChecked,
        elementDetails: getContractorEmployeeDetail,
        deletedFlag,
        setDeletedFlag,
        deleteSelectedDocuments,
        deleteSelectedElement
    };
};

export default EmployeeDetailsBodyApp; // Export the component for use in other parts of the application
